module.exports = __webpack_public_path__ + "img/iconProxy.0ad0f2df.svg";